import { OnDestroy, Directive } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * @deprecated Use @UntilDestroy and untilDestroyed instead
 */
@Directive()
export abstract class UnsubscribeOnDestroy implements OnDestroy {
    protected _cleanup$: Subject<void>;

    constructor() {
        this._cleanup$ = new Subject<void>();
    }

    ngOnDestroy(): void {
        if (this._cleanup$) {
            this._cleanup$.next();
            this._cleanup$.complete();
        }
    }
}
